import {useFormatCurrency} from 'platform/locale';

import {isNil} from 'ramda';

import {OnlineOfferAlternative} from '../api/types/onlineOfferAlternativesTypes';
import {translateWithFallback as t} from '../utils/translateWithFallback';

/**
 * Headline total incl. VAT of an alternative. An applied alternative whose price was cleared
 * (PRICE_MISSING) has none and reads "Price on request"; table cells use "—" instead.
 */
export function useFormatAlternativeTotal() {
  const formatCurrency = useFormatCurrency();

  return (alternative: Pick<OnlineOfferAlternative, 'total'>) =>
    isNil(alternative.total)
      ? t('alternatives.priceOnRequest', 'Price on request')
      : (formatCurrency(
          Number(alternative.total.withVat.amount),
          alternative.total.withVat.currency
        ) ?? '');
}
